import { Select } from "components/Select";

interface Props {
  value?: string;
  onChange: (value: string) => void;
  width?: string | number;
}

const OPTIONS = [
  { value: "", label: "—" },
  { value: "pickup_start", label: "Pickup Date (Oldest)" },
  { value: "-pickup_start", label: "Pickup Date (Newest)" },
  { value: "delivery_eta", label: "Delivery Date (Oldest)" },
  { value: "-delivery_eta", label: "Delivery Date (Newest)" },
  { value: "-latest_price", label: "Price (High to Low)" },
  { value: "latest_price", label: "Price (Low to High)" },
  { value: "-shipment_id", label: "Shipment ID (Newest)" },
];

export function QuoteSortBySelect(props: Props) {
  const { value, onChange, width } = props;

  return (
    <Select
      inputLabel="Sort By"
      defaultValue=""
      value={value ?? ""}
      onChange={onChange}
      options={OPTIONS}
      sx={width !== undefined ? { minWidth: 0, width } : undefined}
    />
  );
}
